"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LabelBase;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _Asterisk = _interopRequireDefault3(require("../../Icon/Asterisk"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _createId = _interopRequireDefault3(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _intl = require("../../utils/intl");

var _react = _interopRequireDefault3(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};
var formatMessage = (0, _intl.messageFormatter)(intlMessages);

function LabelBase(_ref) {
  var label = _ref.label,
      children = _ref.children,
      className = _ref.className,
      labelClassName = _ref.labelClassName,
      wrapperClassName = _ref.wrapperClassName,
      labelFor = _ref.labelFor,
      componentName = _ref.componentName,
      necessity = _ref.necessity,
      necessityIndicator = _ref.necessityIndicator,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["label", "children", "className", "labelClassName", "wrapperClassName", "labelFor", "componentName", "necessity", "necessityIndicator"]);
  var necessityMap = {
    required: "".concat(label, " ").concat(formatMessage('(required)')),
    optional: "".concat(label, " ").concat(formatMessage('(optional)'))
  };
  var icon = null;

  if (necessityIndicator === 'icon' && necessity === 'required') {
    icon = _react["default"].createElement(_Asterisk["default"], {
      role: "presentation",
      className: "spectrum-UIIcon-Asterisk spectrum-fieldLabel-requiredIcon",
      size: "S",
      alt: formatMessage('(required)')
    });
  } // There are 3 cases:
  // 1. No children - only render the <label>, no wrapping div. `labelFor` required.
  // 2. 1 child - render wrapping <div>. Automatically generate child `id` and label `for` attributes.
  // 3. > 1 children - render wrapping <div>. `labelFor` required, along with `id` on child.


  var childArray = _react["default"].Children.toArray(children);

  var id;
  var labelId = otherProps.id || (0, _createId["default"])();
  delete otherProps.id;

  if (childArray.length === 1) {
    // Use the existing id prop, or generate one.
    id = childArray[0].props.id || (0, _createId["default"])();
    var ariaLabelledby = childArray[0].props['aria-labelledby'] || (label ? labelId : null);
    childArray[0] = _react["default"].cloneElement(childArray[0], {
      id: id,
      'aria-labelledby': ariaLabelledby
    });
  }

  if (id && !labelFor) {
    labelFor = id;
  }

  if (!labelFor) {
    console.warn("Missing labelFor attribute on ".concat(componentName, " with label \"").concat(label, "\""));
  }

  var fieldLabelClassName = (0, _classnames["default"])(labelClassName, childArray.length === 0 ? className : null);
  var fieldLabel = label ? _react["default"].createElement("label", (0, _extends2["default"])({
    className: fieldLabelClassName,
    id: labelId,
    htmlFor: labelFor
  }, (0, _filterDOMProps["default"])(otherProps)), necessity && necessityIndicator === 'label' ? necessityMap[necessity] : label, icon && ' ', icon && icon) : _react["default"].createElement("div", (0, _extends2["default"])({
    className: fieldLabelClassName
  }, (0, _filterDOMProps["default"])(otherProps)));

  if (childArray.length > 0) {
    if (wrapperClassName) {
      childArray = _react["default"].createElement("div", {
        className: wrapperClassName
      }, childArray);
    }

    return _react["default"].createElement("div", {
      className: className
    }, fieldLabel, childArray);
  }

  return fieldLabel;
}

LabelBase.defaultProps = {
  necessityIndicator: 'icon'
};